export default "__VITE_ASSET__CN_XJ5ws__"